import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutGoalsSection.css';
import aboutBg from '../../assets/images/about-bg.jpg';
import goalsBg from '../../assets/images/goals-bg.jpg';

const AboutGoalsSection = () => {
  const { t } = useTranslation();
  const isRTL = t('dir') === 'rtl';

  return (
    <section id="about" className="about-goals-section" dir={t('dir')}>
      {/* About Section */}
      <div
        className="section-half about"
        style={{ backgroundImage: `url(${aboutBg})` }}
      >
        <div className="overlay dark">
          <div className='section-container'>
            <h2 className="section-title1">{t('aboutGoals.aboutTitle')}</h2>
            <h3 className="section-subtitle1">{t('aboutGoals.aboutSubtitle')}</h3>
            <p className="section-desc">
              {t('aboutGoals.aboutDesc')}
            </p>
            <button
  className={`contact-btn ${isRTL ? 'rtl-arrow' : 'ltr-arrow'}`}
  onClick={() => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  }}
>
  {t('aboutGoals.contactBtn')}
</button>

          </div>
        </div>
      </div>
      
      {/* Goals Section */}
      <div
        className="section-half goals"
        style={{ backgroundImage: `url(${goalsBg})` }}
      >
        <div className="overlay">
          <div className='section-container'>
            <h2 className="section-title1">{t('aboutGoals.goalsTitle')}</h2>
            <p className="section-desc">
              {t('aboutGoals.goalsDesc')}
            </p>
            <ul className="goals-list">
              {t('aboutGoals.goalsList', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      
    </section>
  );
};

export default AboutGoalsSection;